import { render, staticRenderFns } from "./map_settings.vue?vue&type=template&id=6c96bb8e&scoped=true&"
import script from "./map_settings.vue?vue&type=script&lang=js&"
export * from "./map_settings.vue?vue&type=script&lang=js&"
import style0 from "./map_settings.vue?vue&type=style&index=0&id=6c96bb8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c96bb8e",
  null
  
)

export default component.exports